// extracted by mini-css-extract-plugin
export default {"main":"buttons_main__7wH9O","buttons":"buttons_buttons__KZ8Au","button":"buttons_button__3+0Lg"};